import Form from "../../js/helpers/Form"

/**
 * @typedef {{
 *            payin_config_id: string,
 *            session_key: string,
 *            session_expires_at: string,
 *            amount_due: number,
 *          }} RainforestPaymentIntent
 *
 * @typedef {{id: number, name: string}} FCClient
 *
 * @typedef {{
 *              id: number,
 *              payment_token: ?string,
 *              amount_due: number,
 *              download_url: string,
 *              preview_url: string,
 *              client: FCClient,
 *          }}
 */
export default {
  /**
   *
   * @param invoice
   * @param {import('axios').CancelToken} cancelToken
   * @returns {Promise<{data: {data: RainforestPaymentIntent}}>}
   */
  getRainforestPaymentIntent(invoice, method, amount, cancelToken = null) {
    const formData = {
      payment_token: invoice.payment_token,
      payment_method_type: method,
      payment_amount: amount,
    }
    const url = route("client-portal.rainforest.payment-intent.create", { invoice })

    // Use axios directly if cancelToken provided, otherwise use Form helper
    if (cancelToken) {
      return axios.post(url, formData, { cancelToken })
    }

    return new Form(formData).post(url)
  },

  /**
   * @param {number} client
   * @returns {Promise<{data: {data: {payment_method_config_id: string, session_key: string, session_expires_at: string}}}>}
   */
  getPaymentMethodIntent(client) {
    return axios.post(route("client-portal.payment-method-intent.create", { client }))
  },

  getStripePaymentIntent(invoice, method, amount) {
    return new Form({
      payment_token: invoice.payment_token,
      payment_method_type: method,
      payment_amount: amount,
    }).post(route("client-portal.stripe.payment-intent.create", { invoice }))
  },

  /**
   *
   * @returns {Promise}
   */
  index() {
    return axios.get(route("client-portal.payment-method.index"))
  },

  /**
   * @param client
   * @param payment_method_config_id
   * @returns {Promise}
   */
  show(client, payment_method_config_id) {
    return axios.get(route("client-portal.payment-method.show", { client }), {
      params: { payment_method_config_id },
    })
  },

  /**
   * @param {Number|Object<{id: number}>} client
   * @param {Object<setup_intent_id: string>} setupIntent
   * @returns {Promise<{data: {data: PaymentMethod}}>}
   */
  saveStripeMethod(client, setupIntent) {
    return axios.post(
      route("client-portal.stripe.payment-method.create", {
        client,
        setup_intent_id: setupIntent.id,
      }),
    )
  },

  /**
   * @param client
   * @param paymentMethod
   * @returns {Promise}
   */
  setAsDefault(client, paymentMethod) {
    return axios.patch(route("client-portal.payment-method.set-default", { client, paymentMethod }))
  },

  /**
   * @param paymentMethod
   * @returns {Promise}
   */
  delete(paymentMethod) {
    return axios.delete(route("client-portal.payment-method.delete", { paymentMethod }))
  },

  getUpdatedInvoice(payload) {
    return axios.post(route("client-portal.payments.verify", payload))
  },
}
